const CODES = ("AF AX AL DZ AS AD AO AI AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BQ BA BW BR BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR XK KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB US UY UZ VU VE VN VG VI WF EH YE ZM ZW").split(" ");

let cache = null;

export function countryNames() {
  if (cache) return cache;
  let dn = null;
  try { dn = new Intl.DisplayNames(["en"], { type: "region" }); } catch { dn = null; }
  cache = CODES.map((code) => ({ code, name: (dn && dn.of(code)) || code })).sort((a, b) => a.name.localeCompare(b.name));
  return cache;
}

export function guessCountry() {
  const region = (navigator.language || "").split("-")[1];
  const hit = region && countryNames().find((c) => c.code === region.toUpperCase());
  if (hit) return hit.name;
  return ["Asia/Kolkata", "Asia/Calcutta"].includes(Intl.DateTimeFormat().resolvedOptions().timeZone) ? "India" : "";
}
